// Account and Profile page
$(".sideProfileBtn").click(function () {
  $(".sideProfileBtn").removeClass("active");
  $(this).addClass("active");
  var activeTabId = $(this).attr("data-tabid");
  $(".tabContentInner").hide();
  $(activeTabId).fadeIn(300);
});

$(".sideProfileBtn-m").click(function () {
  var activeTabId = $(this).attr("data-tabid");
  $(".tabContentInner").hide();
  $(activeTabId).fadeIn(300);
  $(this).parent().hide();
  $(".account-back-btn").show();
});

if (window.innerWidth <= 798) {  
  $(".sideProfileBtn").removeClass("active");
  $(".tabContentInner").hide();
  
  $(".sideProfileBtn").click(function () {    
    $(this).parent('.profileSideNav').hide();
    $('.account-back-btn').removeClass('is-hidden');
  });
  $(".account-back-btn").click(function () {
    $(".profileSideNav").show();    
    $(".tabContentInner").hide();    
    $('.account-back-btn').addClass('is-hidden');
  });
}

$(".showNewAddressForm").click(function () {
  $(this).hide();
  $("#add_address").slideDown();
});

$(".cancelAddressForm").click(function () {
  $(".showNewAddressForm").show();
  $("#add_address").slideUp();
});

$(document).ready(function () {
  function getHeaderHeight() {
    let headerHeight = 0;

    if ($("#header").length) {
      headerHeight += $("#header").outerHeight();
    }
    if ($("#mobile-header").length) {
      headerHeight += $("#mobile-header").outerHeight();
    }

    return headerHeight;
  }

  $('a[href^="#"]').on("click", function (e) {
    const targetId = $(this).attr("href");
    const $target = $(targetId);

    if ($target.length) {
      e.preventDefault();

      const headerHeight = getHeaderHeight();
      const targetOffset = $target.offset().top - headerHeight;

      $("html, body").animate(
        {
          scrollTop: targetOffset,
        },
        600 
      );
    }
  });
});
